interface SkillsSectionProps {
  skills: string[];
}

export default function SkillsSection({ skills }: SkillsSectionProps) {
  return (
    <section className="py-12">
      <div className="container">
        <h2 className="mb-6 text-3xl font-bold text-gray-900 dark:text-gray-50">Skills</h2>
        
        <div className="flex flex-wrap gap-2">
          {skills.map(skill => (
            <span
              key={skill}
              className="rounded-full bg-primary-100 px-4 py-2 text-sm font-medium text-primary-700 dark:bg-primary-950 dark:text-primary-300"
            >
              {skill}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
